import React from 'react';
import PlatformDownloaderLinks from './PlatformDownloaderLinks';

export default function HowToDownloadAndroid() {
  const styles = {
    container: {
      padding: '20px',
      maxWidth: '768px',
      margin: '0 auto',
    },
    heading: {
      fontSize: '24px',
      textAlign: 'center',
      marginBottom: '16px',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '16px',
    },
    image: {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '8px',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>How to Download Media on Android</h1>
      <p>1. We don't have an Android app currently, so you need to use a browser (such as Google Chrome) and access <strong>downr.org</strong>.</p>
      <p>2. Paste your target URL and click on the Download button.</p>
      <p>3. You can use the paste feature when you have URL handy. Note that you need to give clipboard permission to do so.</p>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.imgur.com/rzXdPNo.jpeg" 
          alt="home page"
          style={styles.image}
        />
      </div>
      <p>3. You will be navigated to the download page. Choose a download link matching your desired quality/format.</p>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.imgur.com/ELyLgBw.jpeg" 
          alt="download page"
          style={styles.image}
        />
      </div>
      <p>4. Click and hold the download link until you see something like this:</p>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.imgur.com/D6UZHYm.jpeg" 
          alt="download options"
          style={styles.image}
        />
      </div>
      <p>5. Click on <strong>"Download Link"</strong> (In Google Chrome) to save the file to your device's default download location.  In case of other browsers, you may have to click on their respective download option.</p>
      <PlatformDownloaderLinks />
    </div>
  );
}